import { Button } from "@/components/ui/button";
import { ArrowLeft, MapPin, Mail, Globe, Building } from "lucide-react";
import { Link } from "react-router-dom";

export default function Impressum() {
  return (
    <div data-testid="impressum-page" className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <Link to="/">
          <Button variant="ghost" className="mb-8 text-[#b46eb6] hover:bg-[#b46eb6]/5" data-testid="impressum-back-btn">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Zurück zur Startseite
          </Button>
        </Link>

        <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight mb-8" style={{ color: "#1F2937" }}>
          Impressum
        </h1>
        <div className="section-divider mb-8" />

        <div className="prose prose-lg max-w-none space-y-8" style={{ color: "#4B5563" }}>
          
          {/* Angaben gemäß § 5 TMG */}
          <section>
            <h2 className="font-heading text-2xl font-semibold flex items-center gap-2 mb-4" style={{ color: "#1F2937" }}>
              <Building className="w-6 h-6" style={{ color: "#b46eb6" }} />
              Angaben gemäß § 5 TMG
            </h2>
            <div className="bg-gray-50 rounded-xl p-6 space-y-2">
              <p className="font-semibold" style={{ color: "#1F2937" }}>Loos Günter</p>
              <p>Herren-von-Ried Str. 23</p>
              <p>92331 Parsberg-Herrnried</p>
              <p>Deutschland</p>
            </div>
          </section>

          {/* Vertreten durch */}
          <section>
            <h2 className="font-heading text-2xl font-semibold mb-4" style={{ color: "#1F2937" }}>
              Vertreten durch
            </h2>
            <p>
              Christian Selch & Robert Harteis & Günter Loos und das Organisationsteam „Run for Rett"
            </p>
          </section>

          {/* Kontakt */}
          <section>
            <h2 className="font-heading text-2xl font-semibold flex items-center gap-2 mb-4" style={{ color: "#1F2937" }}>
              <Mail className="w-6 h-6" style={{ color: "#b46eb6" }} />
              Kontakt
            </h2>
            <div className="space-y-2">
              <p>
                <strong>E-Mail:</strong>{" "}
                <a href="mailto:info@runforrett.de" className="underline hover:no-underline" style={{ color: "#b46eb6" }}>
                  info@runforrett.de
                </a>
              </p>
              <p>
                <strong>Webseite:</strong>{" "}
                <a href="https://www.runforrett.de" className="underline hover:no-underline" style={{ color: "#b46eb6" }}>
                  www.runforrett.de
                </a>
              </p>
            </div>
          </section>

          {/* Vereinsregister */}
          <section>
            <h2 className="font-heading text-2xl font-semibold mb-4" style={{ color: "#1F2937" }}>
              Vereinsregister
            </h2>
            <p>
              <strong>VR 40160</strong><br />
              Eingetragener gemeinnütziger Verein beim zuständigen Amtsgericht Nürnberg
            </p>
          </section>

          {/* Verantwortlich für den Inhalt */}
          <section>
            <h2 className="font-heading text-2xl font-semibold mb-4" style={{ color: "#1F2937" }}>
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p>
              Zukunft durch medizinische Forschung e.V.<br />
              Herren-von-Ried Str. 23<br />
              92331 Parsberg-Herrnried
            </p>
          </section>

          {/* Haftung für Inhalte */}
          <section>
            <h2 className="font-heading text-2xl font-semibold mb-4" style={{ color: "#1F2937" }}>
              Haftung für Inhalte
            </h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen
              Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir
              als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder
              gespeicherte fremde Informationen zu überwachen.
            </p>
          </section>

          {/* Haftung für Links */}
          <section>
            <h2 className="font-heading text-2xl font-semibold mb-4" style={{ color: "#1F2937" }}>
              Haftung für Links
            </h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
              keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
              Gewähr übernehmen.
            </p>
          </section>

          {/* Urheberrecht */}
          <section>
            <h2 className="font-heading text-2xl font-semibold mb-4" style={{ color: "#1F2937" }}>
              Urheberrecht
            </h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
              unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind als solche
              gekennzeichnet.
            </p>
          </section>

        </div>

        {/* Footer Links */}
        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-wrap gap-4">
          <Link to="/datenschutz" className="text-sm underline hover:no-underline" style={{ color: "#b46eb6" }}>
            Datenschutzerklärung
          </Link>
        </div>
      </div>
    </div>
  );
}
